import {
  ListFill18Icon,
  ListOutline18Icon,
  NewspaperFill18Icon,
  NewspaperOutline18Icon,
} from "@vygruppen/spor-icon-react";
import {
  getLocalStorageOploggTodoTabsSettings,
  setLocalStorageOploggTodoTabsSettings,
} from "api/dropsLocalStorage";
import CollapseButton from "features/CenterContent/shared/Tabs/CollapseButton";
import { Tabs, TabsSides } from "features/CenterContent/shared/Tabs/TabsSides";
import Oplogg from "features/TodoOploggSidebar/Oplogg";
import {
  OploggProvider,
  useOplogg,
} from "features/TodoOploggSidebar/Oplogg/useOplogg";
import Todo from "features/TodoOploggSidebar/Todo";
import useTodo from "features/TodoOploggSidebar/Todo/useTodo";
import { useEffect, useMemo, useState } from "react";
import { CollapsibleWrapper } from "shared/components/CollapsibleWrapper";
import { Flex } from "shared/components/Spor";
import { useSidePanelsState } from "stores/useSidePanelsState";

const todoOploggTabs: Tabs[] = [
  {
    id: "oplogg",
    iconActive: <NewspaperFill18Icon />,
    iconInactive: <NewspaperOutline18Icon />,
    text: "Oplogg",
  },
  {
    id: "todo",
    iconActive: <ListFill18Icon />,
    iconInactive: <ListOutline18Icon />,
    text: "Todo",
  },
];

const TodoOploggSidebarContent = () => {
  const [open, setopen] = useSidePanelsState((state) => [
    state.oploggTodoListOpen,
    state.setOploggTodoListOpen,
  ]);

  const [selectedTabIds, setSelectedTabIds] = useState(
    getLocalStorageOploggTodoTabsSettings(),
  );

  useEffect(() => {
    setLocalStorageOploggTodoTabsSettings(selectedTabIds);
  }, [selectedTabIds]);

  const { oploggNotifications, setOploggNotifications } = useOplogg();

  const { todoNotifications, setTodoNotifications } = useTodo();

  const notifications = useMemo(
    () => ({ oplogg: oploggNotifications, todo: todoNotifications }),
    [oploggNotifications, todoNotifications],
  );

  return (
    <CollapsibleWrapper
      $gridArea="todoOplogg"
      $side="right"
      $open={open}
      $multipleTabs={selectedTabIds.length >= 2}
    >
      <Flex
        flexDirection="column"
        overflowY="auto"
        position="relative"
        borderRadius="6px"
        width="100%"
      >
        <Flex justifyContent="space-between" alignItems="center">
          <CollapseButton
            open={!open}
            setOpen={() => setopen(!open)}
            title="Skjul oplogg"
            inverted
          />
          <TabsSides
            tabs={todoOploggTabs}
            selectedTabIds={selectedTabIds}
            setSelectedTabIds={setSelectedTabIds}
            justifyContent="start"
            allowSplit
            notifications={notifications}
            setNotifications={(value: number[]) => {
              setOploggNotifications(value[0]);
              setTodoNotifications(value[1]);
            }}
          />
        </Flex>
        <Flex overflowY="auto" flex="1" gap="6px">
          {selectedTabIds.includes("oplogg") && <Oplogg />}
          {selectedTabIds.includes("todo") && <Todo />}
        </Flex>
      </Flex>
    </CollapsibleWrapper>
  );
};

export const TodoOploggSidebar = () => (
  <OploggProvider>
    <TodoOploggSidebarContent />
  </OploggProvider>
);
